import toast from './toast';
import { formatFieldName } from './formatters';

interface BackendErrorResponse {
  detail?: string;
  error_type?: string;
  status_code?: number;
  non_field_errors?: string[];
  [field: string]: any;
}

export function handleDRFValidationErrors(data: BackendErrorResponse): boolean {
  let hasErrors = false;

  if (data.detail && typeof data.detail === 'string') {
    if (data.detail.includes('ErrorDetail')) {
      try {
        const parsed = data.detail
          .replace(/ErrorDetail\(string='([^']+)', code='[^']+'\)/g, '"$1"')
          .replace(/'/g, '"');
        const errors = JSON.parse(parsed);
        Object.entries(errors).forEach(([field, messages]) => {
          if (Array.isArray(messages)) {
            messages.forEach((msg: string) => {
              toast.error(`${formatFieldName(field)}: ${msg}`, 5000);
              hasErrors = true;
            });
          }
        });
      } catch {
        toast.error(data.detail, 5000);
        hasErrors = true;
      }
    } else {
      toast.error(data.detail, 5000);
      hasErrors = true;
    }
  }

  if (Array.isArray(data.non_field_errors)) {
    data.non_field_errors.forEach((msg: string) => toast.error(msg, 5000));
    hasErrors = true;
  }

  // Django's model-level constraint violations (e.g. a UniqueConstraint hit
  // directly at the DB layer instead of being pre-empted by serializer
  // validation) report under '__all__', its non-field-errors key - treat it
  // the same as non_field_errors rather than showing a raw, ugly
  // "__all__: Constraint ... is violated" toast.
  if (Array.isArray(data.__all__)) {
    data.__all__.forEach((msg: string) => toast.error(msg, 5000));
    hasErrors = true;
  }

  Object.entries(data).forEach(([field, messages]) => {
    if (['non_field_errors', '__all__', 'detail', 'error_type', 'status_code'].includes(field)) {
      return;
    }

    if (Array.isArray(messages)) {
      messages.forEach((msg) => {
        toast.error(`${formatFieldName(field)}: ${msg}`, 5000);
        hasErrors = true;
      });
    } else if (typeof messages === 'string') {
      // A scalar (non-array) field-level error comes from a serializer's own
      // object-level validate() raising e.g. ValidationError({"name": "..."}))
      // - DRF does not wrap single strings raised this way in a list. These
      // are expected to be shown inline under the relevant form field via
      // parseApiError/setError, not as a toast - just mark it handled so the
      // generic 400 fallback ("Bad request...") doesn't also fire.
      hasErrors = true;
    }
  });

  return hasErrors;
}
